import React from 'react';
import { Monitor, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const SystemAlerts = () => {
  return (
    <div className="system-alerts" style={{ fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif' }}>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="mb-6">
          <Link 
            to="/notifications/center" 
            className="inline-flex items-center text-gray-600 hover:text-gray-900 mb-4"
          >
            <ArrowLeft size={20} className="mr-2" />
            Back to Notification Center
          </Link>
          <h1 className="text-3xl font-bold text-gray-900">System Alerts</h1>
          <p className="text-gray-600 mt-2">
            Monitor system health and performance with real-time alerts.
          </p>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
          <div className="text-center py-12">
            <div className="bg-purple-100 p-4 rounded-2xl w-fit mx-auto mb-6">
              <Monitor size={48} className="text-purple-600" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">System Monitoring</h2>
            <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
              Real-time system health monitoring with performance alerts and capacity warnings. 
              This feature will be available in v1.1.
            </p>
            
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
              <p className="text-yellow-800 text-sm">
                <strong>Coming Soon:</strong> Advanced system monitoring with real-time alerts, 
                performance metrics, and automated capacity management.
              </p>
            </div>

            <button className="bg-purple-600 text-white px-6 py-3 rounded-lg hover:bg-purple-700 transition-colors flex items-center mx-auto">
              <Monitor size={20} className="mr-2" />
              Configure Alerts
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SystemAlerts;
